
/**
 * 응답 데이터
 * @nullable
 */
export type GetApiV1RefundsMyRequests200AllOfData = { [key: string]: unknown } | null;
